import React, {CSSProperties} from 'react';

interface IHeartIconProps {
    width: string, /*default*/
    height?: string,
    color?: string,
    title?: string,
    classes?: string,
    rotationAngle?: number,
    style?: CSSProperties,
    isColorFill?:boolean
}
const HeartIcon = (props: IHeartIconProps) => {
  return (
      <>
          {props.isColorFill ?

              <svg
                  width={props.width}
                  height={props.width}
                  className={props.classes}
                  style={props.style}
                  id="fill-heart"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32" fill={props.color} version="1.1" >
                  <path xmlns="http://www.w3.org/2000/svg"
                        d="M0.256 12.16q0.544 2.080 2.080 3.616l13.664 14.144 13.664-14.144q1.536-1.536 2.080-3.616t0-4.128-2.080-3.584-3.584-2.080-4.16 0-3.584 2.080l-2.336 2.816-2.336-2.816q-1.536-1.536-3.584-2.080t-4.128 0-3.616 2.080-2.080 3.584 0 4.128z"
                        />
              </svg>
              :
              <svg
              width={props.width}
              height={props.width}
              className={props.classes}
              style={props.style}
              id="heart"
              viewBox="0 0 22 22" fill="none" version="1.1" >
                  <path xmlns="http://www.w3.org/2000/svg" id="Vector" d="M19.2373 6.23731C20.7839 7.78395 20.8432 10.2727 19.3718 11.8911L11.9995 20.0001L4.62812 11.8911C3.15679 10.2727 3.21605 7.7839 4.76269 6.23726C6.48961 4.51034 9.33372 4.66814 10.8594 6.5752L12 8.00045L13.1396 6.57504C14.6653 4.66798 17.5104 4.51039 19.2373 6.23731Z" stroke={props.color} strokeWidth="2"/>              </svg>
          }
      </>

  )
};

export default HeartIcon;